export const authentication = {
    displayLoginLogo: true,
    enableGAR: true,
    enableSSO: false,
    firstConnexionRedirection: {
        trainer: '/groups/list/groups'
    },
    activeChangePasswordStrategy: true,
};
